import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import ru from './locales/ru.json';

/**
 * i18n configuration
 * Supported languages: English (en), Russian (ru)
 * Default language: English
 */
i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: en,
      },
      ru: {
        translation: ru,
      },
    },
    lng: 'en', // Default language
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    react: {
      useSuspense: false, // Disable suspense for SSR compatibility
    },
  });

/**
 * Detect and set language from Telegram WebApp
 */
export const initializeLanguage = () => {
  if (typeof window === 'undefined') {
    return;
  }

  // Get language from Telegram WebApp
  // Type assertion is safe here as Telegram WebApp types are defined globally
  const tgLanguage = window.Telegram?.WebApp?.initDataUnsafe?.user?.language_code;
  
  // Map language codes to supported languages
  const languageMap: Record<string, string> = {
    'ru': 'ru',
    'en': 'en',
  };

  // Set language based on Telegram or browser language
  const detectedLanguage = tgLanguage || navigator.language.split('-')[0];
  const language = languageMap[detectedLanguage] || 'en';

  i18n.changeLanguage(language);
};

export default i18n;

